import {Box, Typography} from '@mui/material';

import {
  actions,
  alignmentStatus,
  orangeColors,
  scorePill,
  semantic,
} from '../../../../../layouts/theme/designSystem';

const countDefaultTokens = {
  bgcolor: semantic.info.bg,
  color: actions.primaryHover,
  borderColor: actions.primary,
};

const countWarningTokens = {
  bgcolor: alignmentStatus.warningChipBg,
  color: alignmentStatus.warningChipFg,
  borderColor: scorePill.medium.strokeColor,
};

const countInactiveTokens = {
  bgcolor: orangeColors[5],
  borderColor: orangeColors[3],
};

export interface Props {
  label: string;
  active: boolean;
  onClick: () => void;
  count?: string | number;
  countVariant?: 'default' | 'warning';
}

export const ProfileTabButton = ({
  label,
  active,
  onClick,
  count,
  countVariant = 'default',
}: Props) => {
  const countTokens = countVariant === 'warning' ? countWarningTokens : countDefaultTokens;

  const rootSx = {
    px: 2,
    py: 1.25,
    fontSize: 13,
    cursor: 'pointer',
    color: active ? actions.primary : 'text.secondary',
    fontWeight: active ? 500 : 400,
    fontFamily: 'inherit',
    background: 'none',
    border: 'none',
    borderBottom: `2px solid ${active ? actions.primary : 'transparent'}`,
    mb: '-1px',
    transition: 'all 0.13s',
    userSelect: 'none',
    display: 'flex',
    alignItems: 'center',
    gap: 0.75,
    '&:hover': {color: 'text.primary'},
  };

  const countSx = {
    fontSize: 10,
    fontWeight: 600,
    px: 0.75,
    py: '1px',
    borderRadius: '99px',
    lineHeight: 1.4,
    bgcolor: active ? countTokens.bgcolor : countInactiveTokens.bgcolor,
    color: active ? countTokens.color : 'text.secondary',
    border: `0.5px solid ${active ? countTokens.borderColor : countInactiveTokens.borderColor}`,
  };

  return (
    <Box component='button' type='button' onClick={onClick} sx={rootSx}>
      {label}
      {count != null && (
        <Typography component='span' sx={countSx}>
          {count}
        </Typography>
      )}
    </Box>
  );
};
